// Unpublished Work © 2023-2024 Deere & Company.

export const PROFILE_PIC_PATTERN = /profilePic_([^.]+)/;
export const PLAYBOOK_URL_PATTERN = '^[^:/?#]+:\\/\\/[^/?#]+[^?#]*\\?courseurl=' +
    '[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$';
